import {
  Box,
  Button,
  CardContent,
  Container,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import Arrow from "../../../assets/images/arrowroundzoom.svg";
import Icon1 from "../../../assets/images/i1.svg";
import Icon2 from "../../../assets/images/i2.svg";
import Icon3 from "../../../assets/images/i3.svg";
import MobileStrengthBg from "../../../assets/images/mStrengthBg.svg";
import StrengthBg from "../../../assets/images/strength-bg.webp";

const strengths = [
  {
    id: "01",
    icon: Icon1,
    title: "高品質なシステム開発と",
    description: "低コストの両立を実現",
  },
  {
    id: "02",
    icon: Icon2,
    title: "最新技術を持つ",
    description: "世界レベルの開発者集団",
  },
  {
    id: "03",
    icon: Icon3,
    title: "グローバルな事業理解と",
    description: "安心なマネジメント",
  },
];

const OurStrengthSection = () => {
  const navigate = useNavigate();
  return (
    <Box
      // py={8}
      sx={{
        backgroundImage: {
          xs: `url(${MobileStrengthBg})`,
          sm: `url(${StrengthBg})`,
        },
        py: {
          xs: 6,
          sm: 8,
        },
        backgroundSize: "cover",
        backgroundPosition: "center",
        // height: "100vh",
        width: "100%",
        display: "flex",
        // flexDirection: "column",
        // justifyContent: "center",
        alignItems: "center",
        // textAlign: "center",
        color: "#fff",
        // padding: 2,
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container>
        <Box>
        <Typography
            variant="h6"
            gutterBottom
            sx={{
              background: "linear-gradient(180deg, #F8B62D 0%, #EA5514 100%)",
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              fontWeight: 700,
              fontSize: {
                xs: "14px",
                sm: "24px",
              },
              lineHeight: "33px",
              marginBottom: 0,
            }}
          >
            Our Strength
          </Typography>
          <Typography
            variant="h4"
            gutterBottom
            sx={{
              fontWeight: 700,
              fontSize: {
                xs: "18px",
                sm: "50px",
              },
              color: "#000000",
              lineHeight: {xs:'20px',md:"70px"},
            }}
          >
            私たちの特長
          </Typography>
          <Typography
            // mt={6}
            variant="body1"
            gutterBottom
            sx={{
              fontWeight: 400,
              lineHeight: "36px",
              fontSize: {
                xs: "14px",
                sm: "20px",
              },
              color: "#000000",
              mt: {
                xs: 0,
                sm: 3,
              },
            }}
          >
            グローバルジャパンネットワークはグローバルビジネスとテクノロジーに
          </Typography>
          <Typography
            variant="body1"
            gutterBottom
            sx={{
              fontWeight: 400,
              lineHeight: "36px",
              fontSize: "20px",
              color: "#000000",
            }}
          >
            精通した専門家が、日本企業の成功をサポートします。
          </Typography>

          <Grid container spacing={1} mt={3}>
            {strengths.map((strength) => (
              <Grid item xs={12} sm={6} md={4} key={strength.id}>
                <Stack
                  sx={{
                    width: { xs: "100%", md: "352px" },
                    height: "280px",
                    borderRadius: "16px",
                    backgroundColor: "#fff3d9",
                  }}
                >
                 <Stack px={3} py={2}>
                 <CardContent >
                    <Grid
                      container
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <Typography
                        variant="h5"
                        sx={{
                          fontWeight: 700,
                          fontSize: { xs: "20px", md: "28px" },
                          lineHeight: { xs: "28px", md: "40px" },
                          color: "#000000",
                        }}
                      >
                        {strength.id}
                      </Typography>
                      <img
                        style={{ width: "70px", height: "70px" }}
                        src={strength.icon}
                        alt="icon"
                      />
                    </Grid>

                    <Typography
                      variant="body1"
                      mt={2}
                      sx={{
                        fontWeight: 700,
                        fontSize: { xs: "16px", sm: "20px" },
                        color: "#000000",
                        lineHeight: "28px",
                        marginTop:7
                      }}
                    >
                      {strength.title}
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 700,
                        fontSize: { xs: "16px", sm: "20px" },
                        lineHeight: "28px",
                        color: "#000000",
                        mt: 1,
                      }}
                    >
                      {strength.description}
                    </Typography>
                  </CardContent>
                 </Stack>
                </Stack>
              </Grid>
            ))}
          </Grid>

          <Box display="flex" justifyContent="center" mt={6}>
            <Button
              variant="contained"
              sx={{
                color: "#fff",
                display: "flex",
                alignItems: "center",
                borderRadius: "30px",
                fontSize: "14px",
                width: "auto",
                height: "50px",
                fontWeight: 700,
                fontFamily: "Noto Sans JP, sans-serif",
                padding: "10px 10px 10px 20px",
                background: "linear-gradient(180deg, #F8B62D 0%, #EA5514 100%)",
                transition: "background 0.4s ease, color 0.4s ease",
                "&:hover": {
                  background: "black", // Override gradient with black on hover
                  color: "white", // Change text color to white on hover
                  "& img": {
                    transform: "scale(1.2)", // Zoom in the arrow icon
                  },
                },
              }}
              onClick={() => navigate("/features")}
            >
              特徴を見る
              <Box
                component="img"
                src={Arrow}
                alt="Button image"
                sx={{
                  height: "30px",
                  width: "30px",
                  ml: 3,
                  transition: "transform 0.3s ease",
                  transform: "scale(1)",
                }}
              />
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default OurStrengthSection;
